export interface TokenUsageData {
  inputTokens?: number;
  outputTokens?: number;
  reasoningTokens?: number;
  cachedTokens?: number;                // Both: cache reads (OpenAI 50%, Anthropic 90% discount)
  cacheCreationTokens?: number;         // Anthropic: cache writes (1.25×)
  webSearchRequests?: number;           // Anthropic: $10/1k billing signal
  totalTokens?: number;
  estimatedCostUsd?: number | null;     // Server-computed cost in USD
  estimatedCostDisplay?: string | null; // Server-formatted cost in configured currency (e.g., "~€2.64")
  totalDurationMs?: number | null;      // Server-computed wall-clock duration
}

/**
 * Formats a token count as a compact string: "834", "1.2k", "12.3k", "1.2M"
 */
export function formatTokenCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 10_000) return `${(n / 1000).toFixed(1)}k`;
  if (n < 1_000_000) return `${(n / 1000).toFixed(0)}k`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}

/**
 * Formats a cost as "$0.03", "<$0.01", etc.
 */
export function formatCost(cost: number): string {
  if (cost < 0.005) return "<$0.01";
  if (cost < 0.1) return `$${cost.toFixed(2)}`;
  return `$${cost.toFixed(2)}`;
}

/**
 * Formats a duration in milliseconds as "1.2s", "12s", "1m 23s", etc.
 */
export function formatDuration(ms: number): string {
  const totalSec = Math.round(ms / 1000);
  if (totalSec < 60) return `${totalSec}s`;
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return sec > 0 ? `${min}m ${sec}s` : `${min}m`;
}
